import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom';
import {
    IonContent,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonLoading,
    IonToast,
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonSegment,
    IonSegmentButton,
    IonRow,
    IonCol,
    IonButton,
    IonCheckbox,
    IonFab,
    IonFabButton,
    IonModal,
    IonFooter,
    IonText,
    IonAlert,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonSearchbar
} from '@ionic/react';
import { homeOutline, cartOutline, personOutline, cubeOutline, receiptOutline, arrowUp, closeOutline, add, person, barcode, business, locationOutline, trashOutline, createOutline, addOutline, home, search } from 'ionicons/icons';
import ProductActions from '../../../actions/ProductActions';
import PosActions from '../../../actions/PosActions';

import { getLoginApp } from '../../../utils/functions';
import Select from 'react-select'
import { DebounceInput } from 'react-debounce-input';

interface IProps {
    setData_: any;
    get_: any;
    post_: any;
    get_default: any;
}

interface IState {
    variations_array: any;
    ModalvariationShow: any;
    fieldsvariation: any;
    formErrors: any;
    datalogin: any;
    pages: any;
    total_rows: any;
    searchText: any;
    pageSize: any;
    current_count_data: any;
    variationsDB: any;
    data_pagin_variationsDB: any;
    alertDestroy: any;
}

class Variations extends React.Component<IProps, IState> {
    Modalvariation: React.RefObject<HTMLIonModalElement>;
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;

    constructor(props: any) {
        super(props)
        this.Modalvariation = React.createRef<HTMLIonModalElement>();
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();

        this.state = {
            variations_array: [],
            ModalvariationShow: false,
            fieldsvariation: null,
            formErrors: {},
            datalogin: props.datalogin,

            pages: props.pages,
            total_rows: props.total_rows,
            searchText: props.searchText,
            pageSize: props.pageSize,
            current_count_data: props.current_count_data,

            variationsDB: [],
            data_pagin_variationsDB: [],
            alertDestroy: false
        }
    }

    componentDidMount() {

        this.setState({
            ModalvariationShow: false,
            fieldsvariation: {
                id: null,
                location_prices: []
            },
            datalogin: getLoginApp(),
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            alertDestroy: false
        });
        setTimeout(this.getDataPaginInit.bind(this), 1000);

    }

    getDataPaginInit() {

        if (this.state.total_rows != 0 && this.state.current_count_data == this.state.total_rows && this.state.pages != 0) {
            console.log("getDataPaginInit");
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            return;
        }

        this.props.get_({
            user_id: this.state.datalogin.id,
            typeOption: 'get_list_variations',
            search: this.state.searchText,
            pageSize: this.state.pageSize,
            pages: this.state.pages,
            current_count_data: this.state.current_count_data,
            view_active: 'dashboard_products/configuration'
        }, "api/get_list_variations");
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            variations_array: nextProps.data.data_default && nextProps.data.data_default.variations_array ? nextProps.data.data_default.variations_array : [],

            variationsDB: nextProps.data.variationsDB && nextProps.data.variationsDB ? nextProps.data.variationsDB : [],
            data_pagin_variationsDB: nextProps.data.data_pagin_variationsDB && nextProps.data.data_pagin_variationsDB ? nextProps.data.data_pagin_variationsDB : [],
            pages: nextProps.data.variationsDB && nextProps.data.variationsDB.pages ? nextProps.data.variationsDB.pages : 0,
            total_rows: nextProps.data.variationsDB && nextProps.data.variationsDB.total_rows ? nextProps.data.variationsDB.total_rows : 0,
            current_count_data: nextProps.data.data_pagin_variationsDB ? nextProps.data.data_pagin_variationsDB.length : 0
        });

        if (nextProps.data.view_active == "dashboard_products/unidades") {
            if (nextProps.data.refresh_list) {
                this.setState({
                    pages: 0,
                    pageSize: 10,
                });

                setTimeout(this.getDataPaginInit.bind(this), 1000);
            }
            if (this.ionInfiniteScrollRefData.current) {
                if (nextProps.data.concat_list) {
                    this.ionInfiniteScrollRefData.current.complete();
                }
            }
        }

    }

    openModalvariations(row: any) {
        let fieldsvariation = this.state.fieldsvariation;
        this.setState({
            ModalvariationShow: true,
            fieldsvariation: {
                id: null,
                name: '',
                values: [
                    { id: null, name: '' }
                ],
            }
        });
    }

    dismissModalvariations() {
        this.setState({
            ModalvariationShow: false,
            fieldsvariation: {
                id: null,
                name: '',
                values: [
                    { id: null, name: '' }
                ],
            }
        });
    }

    handleChangevariation(event: any) {
        let fieldsvariation = this.state.fieldsvariation;
        fieldsvariation[event.target.name] = event.target.value;
        this.setState({
            fieldsvariation: fieldsvariation
        });
    }

    SaveDataPost() {
        let fieldsvariation = this.state.fieldsvariation;
        let error = false;
        let formErrors: any = {};
        if (this.state.fieldsvariation && this.state.fieldsvariation.name == "") { formErrors['name'] = "*Campo Requerido"; error = true };

        if (error) {
            this.setState({
                formErrors: formErrors
            });
        } else {

            if (fieldsvariation.id) {
                this.props.post_({
                    typeOption: 'updateDatavariation',
                    action: 'update',
                    user_id: this.state.datalogin.id,
                    fieldsvariation: this.state.fieldsvariation,
                    view_active: 'dashboard_products/unidades'
                }, "api/updateDatavariation");
            } else {
                this.props.post_({
                    typeOption: 'saveDatavariation',
                    action: 'create',
                    user_id: this.state.datalogin.id,
                    fieldsvariation: this.state.fieldsvariation,
                    view_active: 'dashboard_products/unidades'
                }, "api/saveDatavariation");
            }
            this.setState({
                ModalvariationShow: false,
            });
        }


    }

    edit_variation(variation: any) {

        let fieldsvariation = {
            id: variation.id,
            name: variation.name,
            values: variation.values
        };

        if (variation.location_prices) {
            this.setState({
                ModalvariationShow: true,
                fieldsvariation: fieldsvariation,
            });
        } else {
            this.setState({
                ModalvariationShow: true,
                fieldsvariation: fieldsvariation
            });
        }


    }
    addRemovedValues(action: any, row: any, key: any) {
        console.log(action, row, key);
        let fieldsvariation = this.state.fieldsvariation;
        let new_data: any = [];
        if (action == "add") {
            new_data = fieldsvariation.values ? fieldsvariation.values : [];
            new_data.push({ id: null, name: '' });
        } else {
            fieldsvariation.values && fieldsvariation.values.map((val: any, key_: any) =>
                key_ != key ?
                    new_data.push(val)
                    : null
            );
        }
        fieldsvariation['values'] = new_data;
        this.setState({
            fieldsvariation: fieldsvariation
        });
        console.log(fieldsvariation);
    }
    render_variations(row: any, key: any) {
        return (
            <div className='card_line' key={key}>
                <IonRow >
                    <IonCol col-12 size='12'>
                        <label className='text-sm font-medium text-g60'><strong>Nombre:</strong> {row.name}</label>
                        <br />
                        <label className='text-sm font-medium text-g60'><strong>Valores:</strong> {
                            row.values.map((val: any) => val.name).join(', ')
                        }</label>
                    </IonCol>
                    <IonCol col-12 size='12' className='text-center'>
                        <IonButton size='small'
                            onClick={() => this.edit_variation(row)}
                        >
                            <div>
                                <IonIcon
                                    color="#ffffff"
                                    slot="icon-only"
                                    icon={createOutline} // Puedes cambiar 'add' por 'createOutline' si tienes ese icono
                                    size="small"

                                />
                            </div>
                        </IonButton>
                        <IonButton size='small' color={'danger'}
                            onClick={
                                e => this.setState({ alertDestroy: true, fieldsvariation: row })
                            }
                        >
                            <div>
                                <IonIcon
                                    color="light"
                                    slot="icon-only"
                                    icon={trashOutline}
                                    size="small"
                                />
                            </div>
                        </IonButton>
                    </IonCol>
                </IonRow>
            </div >
        );
    }

    SendDestroy() {
        this.props.post_({
            typeOption: 'destroyDatavariation',
            action: 'destroy',
            user_id: this.state.datalogin.id,
            fieldsvariation: this.state.fieldsvariation,
            view_active: 'dashboard_products/unidades'
        }, "api/destroyDatavariation");
        this.setState({
            alertDestroy: false
        });
    }

    onChangeForValuesDetailsArray(index: any, e: any) {
        let fieldsvariation = this.state.fieldsvariation;

        if (e.target.name == 'values') {
            let values_array = fieldsvariation.values;

            const newArr = values_array.map((item: any, i: any) => {
                if (index === i) {
                    return { ...item, name: e.target.value };
                } else {
                    return item;
                }
            });

            fieldsvariation['values'] = newArr;
            this.setState({
                fieldsvariation: fieldsvariation
            });
        }
    }

    render_values(values: any) {
        let array_values = values;
        let render_values: any = [];
        array_values.map((val: any, key: any) => {
            {
                key == 0 ?
                    render_values.push(
                        <IonCol col-12 size='12' key={key}>
                            <label>{"Variación " + (key + 1)}: </label>
                            <div className="inputWithIcon">
                                <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                <input className='inputform'
                                    type="text"
                                    value={val.name ?? ""}
                                    onChange={(e) => this.onChangeForValuesDetailsArray(key, { target: { name: "values", value: e.target.value } })}
                                />
                                <IonButton size="small"
                                    onClick={(ev) => this.addRemovedValues('add', values, key)}
                                ><IonIcon icon={addOutline}></IonIcon></IonButton>
                            </div>
                        </IonCol>
                    )
                    :
                    render_values.push(
                        <IonCol col-12 size='12' key={key}>
                            <label>{"Variación " + (key + 1)}: </label>
                            <div className="inputWithIcon">
                                <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                <input className='inputform'
                                    type="text"
                                    value={val.name ?? ""}

                                    onChange={(e) => this.onChangeForValuesDetailsArray(key, { target: { name: "values", value: e.target.value } })}
                                />
                                <IonButton size="small" color={'danger'}
                                    onClick={(ev) => this.addRemovedValues('removed', values, key)}
                                >-</IonButton>
                            </div>
                        </IonCol>
                    );
            }

        });
        return render_values;
    }

    setSearchText(e: any) {
        const value = e.target.value;
        this.setState({
            searchText: value.toLowerCase(),
            pages: 0,
            pageSize: 10,

        });

        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    render() {
        const {
            fieldsvariation,
            ModalvariationShow,
            variations_array,
            formErrors,
            data_pagin_variationsDB,
            variationsDB,
            total_rows,
            current_count_data,
            pages,
            alertDestroy,
            searchText

        } = this.state;

        let data_render_variations = [];
        if (data_pagin_variationsDB && data_pagin_variationsDB.length > 0) {
            data_render_variations = [];
            data_render_variations = data_pagin_variationsDB.map((val: any, key: any) =>
                this.render_variations(val, key)
            );
        };
        return (
            <IonContent>
                <IonAlert
                    backdropDismiss={false}
                    isOpen={alertDestroy}
                    header={'Confirmar'}
                    //subHeader={'Verifique si conexión a internet.'}
                    message={'¿Desea eliminar la variación?'}
                    buttons={[
                        /*{
                          text: 'Conservar',
                          handler: e => {
                            this.SendCon(e);
                          }
                        },*/
                        {
                            text: 'Si',
                            handler: (e) => {
                                this.SendDestroy();
                            }
                        },
                        {
                            text: 'No',
                            handler: e => {
                                this.setState({
                                    alertDestroy: false
                                });
                            }
                        }
                    ]}
                />
                <IonRow>
                    <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                        <div style={{ display: "none" }}>
                            <IonSearchbar onIonChange={e => this.setSearchText(e)} value={searchText}></IonSearchbar>
                        </div>
                    </IonCol>
                    <IonCol col-12 size='12' class='divflex'>
                        <IonIcon icon={search} className='iconseach'></IonIcon>
                        <DebounceInput
                            className='btn_search'
                            placeholder={'Buscar por nombre'}
                            minLength={2}
                            debounceTimeout={2000}
                            value={searchText}
                            onChange={e => this.setSearchText(e)} />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol col-12 size='12' >
                        {data_render_variations && data_render_variations.length > 0 ? data_render_variations :
                            <IonCol col-12 size='12' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100px' }}>
                                <IonText color="medium" style={{ fontWeight: 'bold', textAlign: 'center' }}>
                                    <h5 style={{ margin: 0, fontWeight: 'bold' }}>No hay valores disponibles</h5>
                                </IonText>
                            </IonCol>
                        }
                    </IonCol>
                    <IonModal onDidDismiss={this.dismissModalvariations.bind(this)} isOpen={ModalvariationShow} ref={this.Modalvariation} trigger="open-modal">
                        <IonContent className="ion-padding">
                            <IonHeader >
                                <IonToolbar color="primary">
                                    <IonTitle>{fieldsvariation && fieldsvariation.id ? 'Editar Variación' : 'Nueva Variación'}</IonTitle>
                                    <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={this.dismissModalvariations.bind(this)}>
                                        <IonIcon icon={closeOutline}></IonIcon>
                                    </IonButton>
                                </IonToolbar>
                            </IonHeader>

                            <IonRow>
                                <IonCol col-12 size='12'>
                                    <label>Nombre: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                        <input
                                            className='inputform'
                                            type="text"
                                            placeholder="Nombre de la variación"
                                            onChange={this.handleChangevariation.bind(this)}
                                            value={(fieldsvariation && fieldsvariation.name) ?? ""}
                                            name="name" />
                                    </div>
                                    {formErrors && formErrors.name && (
                                        <>
                                            <IonText color="danger" className="ion-padding-start">
                                                <small>{formErrors.name}</small>
                                            </IonText>
                                            <br />
                                        </>
                                    )}
                                </IonCol>
                                {
                                    fieldsvariation && fieldsvariation.values && fieldsvariation.values.length > 0 ? (
                                        <IonCol col-12 size='12'>
                                            {this.render_values(fieldsvariation.values)}
                                        </IonCol>
                                    ) : (
                                        <IonCol col-12 size='12' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100px' }}>
                                            <IonText color="medium" style={{ fontWeight: 'bold', textAlign: 'center' }}>
                                                <h1 style={{ margin: 0, fontWeight: 'bold' }}>No hay valores disponibles</h1>
                                            </IonText>
                                        </IonCol>
                                    )
                                }
                            </IonRow>
                        </IonContent>
                        <IonFooter collapse="fade" className='footerfixed'>
                            <IonToolbar>
                                <IonButtons slot="start">
                                    <IonButton color="dark" onClick={() => this.dismissModalvariations()}>
                                        Cancel
                                    </IonButton>
                                </IonButtons>
                                <IonButtons slot="end">
                                    <IonButton color="primary" strong={true} onClick={() => this.SaveDataPost()}>
                                        Guardar
                                    </IonButton>
                                </IonButtons>
                            </IonToolbar>
                        </IonFooter>
                    </IonModal>
                    <div
                        style={{
                            position: 'fixed',
                            bottom: '16px',
                            right: '16px',

                        }}
                    >
                        <IonFabButton onClick={(e) => this.openModalvariations(e)} color="primary">
                            <IonIcon icon={add}></IonIcon>
                        </IonFabButton>
                    </div>
                </IonRow>
                <IonInfiniteScroll threshold="50px" ref={this.ionInfiniteScrollRefData}
                    onIonInfinite={(event) => {
                        this.getDataPaginInit();
                    }}
                >
                    <IonInfiniteScrollContent loadingText="Cargando mas datos..." loadingSpinner="bubbles"></IonInfiniteScrollContent>

                </IonInfiniteScroll>
            </IonContent>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
        post_: PropTypes.func.isRequired,

    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setData_: (data: any, name: string) => dispatch(ProductActions.setData(data, name)),
        get_: (fields: any, controller: string) => dispatch(ProductActions.get_(fields, controller)),
        post_: (data: any, controller: string) => dispatch(ProductActions.post_(data, controller)),
        get_default: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Variations);
